import { classNames } from '@dimjs/utils';
import { CSSProperties, ReactNode, useLayoutEffect, useState } from 'react';
import { fabricViewport, px2rem } from '../utils';
import './style.less';

export interface IProgressProps {
  value: number;
  size?: number;
  gap?: number;
  className?: string;
  isRotate?: boolean;
  children?: ReactNode;
}

export const Progress = (props: IProgressProps) => {
  const [wrapperStyle, setWrapperStyle] = useState<CSSProperties>({});
  const [pieStyle, setPieStyle] = useState<CSSProperties>({});
  const [barLeftStyle, setBarLeftStyle] = useState<CSSProperties>({});
  const [barRightStyle, setBarRightStyle] = useState<CSSProperties>({});
  const [shadowStyle, setShadowStyle] = useState<CSSProperties>({});
  const [isOver50, setIsOver50] = useState<boolean>(false);
  const [renderFlag, setRenderFlag] = useState<boolean>(false);

  const px2px = (value: number) => {
    return `${Math.ceil(Number(px2rem(value).split('rem')[0]) * fabricViewport().currRem)}px`;
  };
  useLayoutEffect(() => {
    const { value, size = 200, gap = 12 } = props;
    const rotate = value * 360;
    const pos = px2px(size);
    const wrapperStyle: CSSProperties = {
      width: pos,
      height: pos,
      padding: px2rem(gap),
    };
    const pieStyle: CSSProperties = {
      clip: `rect(0, ${px2px(size)},${px2px(size)}, ${px2px(size / 2)})`,
    };
    const barLeftStyle: CSSProperties = {
      WebkitTransform: `rotate(${rotate}deg)`,
      transform: `rotate(${rotate}deg)`,
      borderWidth: px2rem(gap),
      clip: `rect(0,${px2px(size / 2)},${px2px(size)},0)`,
    };
    const barRightStyle: CSSProperties = {
      borderWidth: px2rem(gap),
      clip: `rect(0,${px2px(size / 2)},${px2px(size)},0)`,
    };
    const shadowStyle: CSSProperties = {
      borderWidth: px2rem(gap),
    };
    const isOver50 = rotate > 180 ? true : false;
    setWrapperStyle(wrapperStyle);
    setPieStyle(pieStyle);
    setBarLeftStyle(barLeftStyle);
    setBarRightStyle(barRightStyle);
    setShadowStyle(shadowStyle);
    setIsOver50(isOver50);
    setRenderFlag(true);
  }, [props]);

  if (!renderFlag) {
    return null;
  }

  const className = classNames('v-progress', { 'v-progress-rotate': props.isRotate }, props.className);

  return (
    <div style={wrapperStyle} className={className}>
      {props.children}
      <div className={classNames({ pie: true, over50: isOver50 })} style={pieStyle}>
        <div className="half-circle left-side" style={barLeftStyle}></div>
        <div className="half-circle right-side" style={barRightStyle}></div>
      </div>
      <div className="track" style={shadowStyle}></div>
    </div>
  );
};
